import { NAV_CHANNELS } from '~modules/nav/js/nav-constants';
import { SUBSCRIPTION_STATUSES } from '~modules/profile/js/profile-constants';

/* eslint-disable import/prefer-default-export */
/**
 * @description
 * returns the navigation channel based on the user's subscription status
 *
 * @param {boolean} isLoggedIn - whether or not user is logged in
 * @param {String} subscriptionStatus - enum representing the subscription status of the user
 * @returns {String} - the corresponding navigation channel
 */
export function getChannelForSubscriptionStatus(isLoggedIn, subscriptionStatus) {
    if (!isLoggedIn) return NAV_CHANNELS.UNAUTHENTICATED;
    return subscriptionStatus === SUBSCRIPTION_STATUSES.nonSubscriber ? NAV_CHANNELS.NON_SUBSCRIBER :
        NAV_CHANNELS.SUBSCRIBER;
}
